import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FlowSection from './components/FlowSection';
import ProductsSection from './components/ProductsSection';
import ValueSection from './components/ValueSection';
import NichesSection from './components/NichesSection';
import CasesSection from './components/CasesSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <FlowSection />
      <ProductsSection />
      <ValueSection />
      <NichesSection />
      <CasesSection />
      <CTASection />
      <Footer />
    </main>
  );
}